<template>
    <form class="v31-form v31-form_auth" @submit.prevent="submit">
        <CustomInputText
          :input-title="'Логин'"
          :input-name="'login'"
          :input-type="'text'"
          :required='true'
          v-model="login"/>
        <CustomInputText
          :input-title="'Пароль'"
          :input-name="'password'"
          :input-type="'password'"
          :required='true'
          v-model="password"/>
        <button type="submit" class="v31-btn v31-btn_green">Войти</button>
    </form>
</template>

<script type="text/javascript">
import axios from '@/services/axios'
import CustomInputText from '@/components/CustomInputText'
export default {
    name: 'auth',
    data(){
        return {
            login: '',
            password: '',
        }
    },
    methods: {
        async submit(){
            let response = await axios.post('/backend/login',{
                login: this.login,
                password: this.password,
            });
            
            if(response && response.data && response.data.result === 'OK') {
                document.location = '/';
                // this.$router.push('/');
            }

        },
    },
    components: {
        CustomInputText
    },
}
</script>

<style type="text/css">
.v31-form_auth{
    max-width: 250px;      
}
</style>